export const PROFILE_QUERY_KEYS = {
  TOKEN: [ 'profile', 'token' ],
  TOKEN_PRICE: [ 'profile', 'token', 'price' ],
  TOKEN_LIST: [ 'profile', 'token', 'list' ],
  PROJECT: [ 'profile', 'project' ],
}